const getNumHeroesInSubmode = (submode_key) => {
  for (let i of [11, 7, 5, 3, 2, 1]) { // yes you have to go backwards, or "11v11" returns 1
    if (submode_key.includes(`${i}man`) || submode_key.includes(`${i}v${i}`)) {
      return i;
    }
  }
};
module.exports = getNumHeroesInSubmode;
